import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { QuoteForm } from "@/components/QuoteForm";
import { COMPANY } from "@/lib/site-data";
import { DotGrid, DiagonalLines, FloatingShape } from "@/components/Deco";

export const Contact = () => {
  return (
    <section
      id="kapcsolat"
      data-testid="contact-section"
      className="bg-[#0B192C] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
        <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#EA580C] blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#1E3E62] blur-3xl" />
      </div>
      <DiagonalLines className="absolute inset-0 text-white" opacity={0.04} />
      <DotGrid
        className="absolute top-20 right-20 w-72 h-72 opacity-30"
        color="rgba(234,88,12,0.5)"
      />

      <div
        id="ajanlat"
        className="relative max-w-7xl mx-auto px-4 md:px-8 section-pad"
      >
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left – contact info */}
          <div className="lg:col-span-5">
            <span className="text-[#EA580C] uppercase tracking-[0.18em] text-xs font-semibold">
              Kapcsolat
            </span>
            <h2 className="mt-3 font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Kérjen ajánlatot{" "}
              <span className="text-[#EA580C]">még ma</span>.
            </h2>
            <p className="mt-5 text-gray-300 text-base sm:text-lg leading-relaxed max-w-md">
              Töltse ki az űrlapot, hamarosan jelentkezünk.
            </p>

            <div className="mt-10 space-y-5">
              <a
                data-testid="contact-phone"
                href={`tel:${COMPANY.phoneRaw}`}
                className="flex items-start gap-4 group"
              >
                <div className="w-11 h-11 rounded-md bg-[#EA580C] flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-400">
                    Telefon
                  </div>
                  <div className="font-heading font-bold text-white text-lg group-hover:text-[#EA580C] transition-colors">
                    {COMPANY.phone}
                  </div>
                </div>
              </a>

              <a
                data-testid="contact-email"
                href={`mailto:${COMPANY.email}`}
                className="flex items-start gap-4 group"
              >
                <div className="w-11 h-11 rounded-md bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-400">
                    E-mail
                  </div>
                  <div className="font-heading font-semibold text-white text-base group-hover:text-[#EA580C] transition-colors">
                    {COMPANY.email}
                  </div>
                </div>
              </a>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-400">
                    Cím
                  </div>
                  <div className="font-heading font-semibold text-white text-base">
                    {COMPANY.address}
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="text-xs uppercase tracking-widest text-gray-400">
                    Nyitvatartás
                  </div>
                  <ul className="mt-1 space-y-0.5">
                    {COMPANY.hours.map((row) => (
                      <li
                        key={row.d}
                        className="flex items-center justify-between gap-6 text-sm text-gray-200"
                      >
                        <span>{row.d}</span>
                        <span className="font-medium text-white">{row.h}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-10 rounded-lg overflow-hidden border border-white/10">
              <iframe
                title="Fortuna Ponyva – Dunaharaszti"
                src={COMPANY.mapEmbed}
                width="100%"
                height="240"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
              />
            </div>
          </div>

          {/* Right – form */}
          <div className="lg:col-span-7">
            <QuoteForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
